import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '@chakra-ui/react';
import { dequeueNotification } from 'state/slices/notificationsSlice';
import { RootState } from 'state/store';

import NotificationCard from './NotificationCard';

export const NotificationListener = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const queue = useSelector((state: RootState) => state.notifications.queue);
  const toastedIds = useRef(new Set<string>());

  useEffect(() => {
    queue
      .filter((notification) => !notification.read) // Only show unread notifications as popups
      .forEach((notification) => {
        const { id, persist = true } = notification;

        if (toastedIds.current.has(id)) return;

        toastedIds.current.add(id);

        toast({
          id,
          position: 'top-right',
          duration: notification.duration ?? 5000,
          containerStyle: {
            borderRadius: '2xl',
            overflow: 'hidden',
          },
          render: () => (
            <NotificationCard
              id={notification.id}
              status={notification.status}
              title={notification.title}
              message={notification.message}
              date={notification.date}
              compact
              clearAllNotifications={() => toast.closeAll()}
              type={notification.type}
              metadata={notification.metadata}
            />
          ),
        });

        if (!persist) {
          dispatch(dequeueNotification(id));
        }
      });
  }, [queue, toast, dispatch]);

  return null;
};
